import { render, staticRenderFns } from "./StatisticsInventoryPanel.vue?vue&type=template&id=017fa5d6"
import script from "./StatisticsInventoryPanel.vue?vue&type=script&lang=js"
export * from "./StatisticsInventoryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports